"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentsTable_en_us = void 0;
function componentsTable_en_us() {
    return {
        "components.table.field": "Field",
        "components.table.key": "Key",
        "components.table.value": "Value",
        "components.table.addentry.text": "Text",
        "components.table.addentry.number": "Number",
        "components.table.addentry.boolean": "Yes/No"
    };
}
exports.componentsTable_en_us = componentsTable_en_us;
